module.exports = __webpack_public_path__ + "static/media/physical_background.e01d8e76.png";